import React, { useContext, useCallback } from 'react'
import { m, LazyMotion, domAnimation } from "framer-motion"
import { MainContext } from "../../context/mainContext";

export const EventCalendar = ({ eventData }) => {
    const ctx = useContext(MainContext)
    
    const today = new Date()
    const eventStartDay = new Date(eventData.dateRange.split(' - ')[0])
    const eventEndDay = new Date(eventData.dateRange.split(' - ')[1])
    const eventStartHour = eventData.time.split(" to ")[0]
    const eventEndHour = eventData.time.split(" to ")[1]
    const eventEndDate = new Date(eventEndDay.toLocaleString('default', { year: 'numeric', month: 'long', day: 'numeric' }) + " " + eventEndHour)
    const eventStartDate = new Date(eventStartDay.toLocaleString('default', { year: 'numeric', month: 'long', day: 'numeric' }) + " " + eventStartHour)
    
    // Calculating the time difference between two dates
    let diffInEndTime = Math.ceil((eventEndDate.getTime() - today.getTime()) / 1000)
    let diffInStartTime = Math.ceil((eventStartDate.getTime() - today.getTime()) / 1000)
    
    // calculate (and substract) whole days
    const daysToStart = Math.floor(diffInStartTime / (3600 * 24))
    const daysToEnd = Math.floor(diffInEndTime / (3600 * 24))

    if (daysToEnd > 0) {
        diffInEndTime -= daysToEnd * 3600 * 24
    }
    if (daysToStart > 0) {
        diffInStartTime -= daysToStart * 3600 * 24
    }
    
    // calculate (and substract) whole hours
    // const hoursToEnd = Math.floor(diffInEndTime / 3600) % 24
    const hoursToStart = Math.floor(diffInStartTime / 3600) % 24

    const bookAppointmentHandler = useCallback(
        () => {
            ctx.openPopup({
                class: 'small',
                title: 'Book Appointment',
                content:    <iframe id="bookAppointmentIFrame"
                                title="Book Appointment"
                                width="100%"
                                height="700px"
                                frameBorder="0"
                                src={eventData.schedulingUrl}>
                            </iframe>
            })
        },
        [eventData],
    )
    
    return (
        <LazyMotion features={domAnimation}>
            <m.div 
                className="event"
                animate={{
                    y: [30, 0],
                    opacity: [0, 1],
                    transition: {
                        delay: 1.5,
                        duration: .5,
                    },
                }}
            >
                <div className="date-info">
                    { daysToStart >= 0 && hoursToStart >= 0 && <div>{daysToStart}<span>days</span></div> }
                    { daysToStart >= 0 && hoursToStart >= 0 && <div>{hoursToStart}<span>hours</span></div> }
                </div>
                <div className="detail">
                    <div className="hdr">{ daysToStart >= 0 && hoursToStart > 0 ? 'Upcoming Event' : 'Happening Today'}</div>
                    <h5>{eventData && eventData.name}</h5>
                    <div className="date">{eventData && eventData.dateRange.replace(/,/g, ', ')}</div>
                </div>
                <div className="controls">
                    {eventData && eventData.schedulingUrl && <a href='#' onClick={bookAppointmentHandler} className="btn btn-primary btn-primary--ghost">Book Appointment</a>}
                </div>
            </m.div>
        </LazyMotion>
    )
}
